import { useState } from 'react'

import { ConfidencePlot } from '../common/confidence-plot/confidence-plot'
import { formatService } from '../common/format.service'
import { useTooltipDisplayContext } from '../common/tooltip/tooltip.context'
import { useStyles } from './forest-swimlane.style'

export const ForestSwimlane = function ({ analysis, xScale, width, rowHeight, hideBottomLine, hasMultipleSwimlanes = false }) {
  const classes = useStyles()

  const [ isHover, setIsHover ] = useState(false)
  const [ highlightGroupIndex, setHighlightGroupIndex ] = useState()
  const [, setTooltipDisplayData] = useTooltipDisplayContext()

  const forestSwimlaneHeight = analysis.groups.length * rowHeight

  function onMouseOver () {
    setIsHover(true)
  }

  function onMouseLeave () {
    setIsHover(false)
  }

  function showTooltip ({ groupLabel, risk, ciLo, ciHi }) {
    const primaryValue = (ciLo && ciHi) ? `${formatRisk(risk)} (${formatRisk(ciLo)} - ${formatRisk(ciHi)})` : formatRisk(risk)
    setIsHover(true)
    setTooltipDisplayData({
      primaryValue,
      secondaryValue: groupLabel
    })
  }

  function hideTooltip () {
    setTooltipDisplayData()
  }

  function formatRisk (risk) {
    return formatService.formatNumber(risk)
  }

  return (
    <g>
      {hasMultipleSwimlanes && (
        <>
          { isHover && (
            <rect
              className={classes.selectedBackground}
              x={0}
              y={0}
              width={width}
              height={forestSwimlaneHeight}
              onMouseOver={onMouseOver}
              onMouseLeave={onMouseLeave}
            />
          )
          }
          <text x={4} y={14} className={classes.analysisLabel}>
            {analysis.label}
          </text>
          <rect
            x={0}
            y={0}
            width={width}
            height={forestSwimlaneHeight}
            fill="transparent"
            onMouseOver={onMouseOver}
            onMouseLeave={onMouseLeave}
          />
        </>
      )}
      <polyline
        points={`0,${forestSwimlaneHeight} 0,0 ${width},0 ${width},${forestSwimlaneHeight} ${hideBottomLine ? '' : `0,${forestSwimlaneHeight}`}`}
        className={classes.border}
      />
      { analysis.groups.map(({ key, label, risk, ciLo, ciHi, color }, groupIndex) => {
        const midPoint = rowHeight / 2
        const yTranslate = groupIndex * rowHeight

        return (
          <g
            key={key}
            className={`${classes.pointGroup} ${highlightGroupIndex === groupIndex ? classes.dropshadow : ''}`}
            transform={`translate(0,${yTranslate})`}
            onMouseOver={() => {
              showTooltip({ groupLabel: label, risk, ciLo, ciHi })
              setHighlightGroupIndex(groupIndex)
            }}
            onMouseLeave={() => {
              hideTooltip()
              setHighlightGroupIndex()
            }}
          >
            <ConfidencePlot
              value={risk}
              ciLo={ciLo}
              ciHi={ciHi}
              xScale={xScale}
              y={midPoint}
              color={color}
              label={formatRisk(risk)} />
          </g>
        )
      })}
    </g>
  )
}
